import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

export const PageContent = ({ children }) => {
    return (
        <Container maxWidth="edia-lg" sx={{ mt: "100px", mb: "100px" }}>
            <Box sx={{ flexGrow: 1 }}>{children}</Box>
        </Container>
    );
};
